/*
 * Auto-scroll while dragging: hold a visit near the edge of the page (or of a board that scrolls) and it scrolls that
 * way, faster the closer you get. Starts on dragstart, stops on drop or dragend.
 */
const EDGE = 80;
const MAX_STEP = 22;

const step = (gap: number) => (gap < EDGE ? Math.ceil((1 - Math.max(gap, 0) / EDGE) * MAX_STEP) : 0);

/** The nearest box under the pointer that scrolls on its own (the week board), if any. */
function scrollerOf(start: Element | null): HTMLElement | null {
  for (let el = start; el && el !== document.body; el = el.parentElement) {
    if (!(el instanceof HTMLElement)) continue;
    const s = getComputedStyle(el);
    const canY = /(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight;
    const canX = /(auto|scroll)/.test(s.overflowX) && el.scrollWidth > el.clientWidth;
    if (canY || canX) return el;
  }
  return null;
}

export function dragAutoScroll(): void {
  let x = -1;
  let y = -1;
  let under: Element | null = null;
  let frame = 0;
  const onOver = (e: DragEvent) => {
    x = e.clientX;
    y = e.clientY;
    under = e.target instanceof Element ? e.target : null;
  };
  const tick = () => {
    if (y >= 0) {
      const box = scrollerOf(under);
      if (box) {
        const r = box.getBoundingClientRect();
        box.scrollBy(step(r.right - x) - step(x - r.left), step(r.bottom - y) - step(y - r.top));
      }
      window.scrollBy(0, step(window.innerHeight - y) - step(y));
    }
    frame = requestAnimationFrame(tick);
  };
  const end = () => {
    cancelAnimationFrame(frame);
    document.removeEventListener("dragover", onOver);
    document.removeEventListener("drop", end);
    document.removeEventListener("dragend", end);
  };
  document.addEventListener("dragover", onOver);
  document.addEventListener("drop", end);
  document.addEventListener("dragend", end);
  frame = requestAnimationFrame(tick);
}
